import styled, { keyframes } from "styled-components";

const slideUp = keyframes`
  0% { opacity: 0; transform: translateY(30px); }
  100% { opacity: 1; transform: translateY(0); }
`;

const Wrapper = styled.footer`
  background: linear-gradient(135deg, #1b0d0d, #4b2e2e);
  color: #f3f3f3;
  padding: 60px 20px 25px;
  font-family: "Poppins", sans-serif;

  .footer-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
    gap: 35px;
    max-width: 1200px;
    margin: 0 auto;
    align-items: start;
  }

  .animate {
    animation: ${slideUp} 0.8s ease forwards;
  }

  .footer-section h2,
  .footer-section h3 {
    color: #fff;
    margin-bottom: 12px;
    font-weight: 600;
    font-size: 18px;
  }

  .footer-section p,
  .footer-section a {
    font-size: 14px;
    line-height: 1.6;
    color: #ccc;
    text-decoration: none;
    transition: color 0.3s ease, transform 0.3s ease;
  }

  .footer-section a:hover {
    color: #ffb74d;
  }

  .footer-section ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .footer-section ul li {
    margin: 6px 0;
    transition: color 0.3s ease;
  }

  .footer-section ul li:hover {
    color: #ffb74d;
  }

  .footer-logo {
    width: 100px;
    margin-bottom: 10px;
    border-radius: 8px;
  }

  .contact-item {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 8px 0;
    font-size: 14px;
  }

  .social-icons {
    margin-top: 15px;
    display: flex;
    gap: 14px;
  }

  .social-icons img,
  .social-icons .social-wa-icon {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    cursor: pointer;
    background: #fff2;
    padding: 5px;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    box-sizing: border-box;
  }

  .social-icons .social-wa-icon {
    color: #25d366;
  }

  .social-icons img:hover,
  .social-icons .social-wa-icon:hover {
    transform: scale(1.15);
    box-shadow: 0 0 10px #ffb74d;
  }

  .footer-bottom {
    text-align: center;
    padding-top: 20px;
    border-top: 1px solid #444;
    margin-top: 25px;
    font-size: 13px;
    color: #cccccc;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }

  .developer-credit {
    background: rgba(255, 255, 255, 0.05);
    padding: 12px 25px;
    border-radius: 30px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(10px);
    display: flex;
    flex-direction: column;
    gap: 6px;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    margin-bottom: 10px;
  }

  .developer-credit:hover {
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 183, 77, 0.4);
    transform: translateY(-4px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25), 0 0 15px rgba(255, 183, 77, 0.1);
  }

  .developer-credit p {
    margin: 0;
    font-size: 13px;
    color: #ececec;
    line-height: 1.4;
  }

  .developer-credit a {
    color: #ffb74d;
    font-weight: 600;
    text-decoration: none;
    position: relative;
    transition: color 0.3s ease;
  }

  .developer-credit a::after {
    content: '';
    position: absolute;
    width: 100%;
    transform: scaleX(0);
    height: 1px;
    bottom: -2px;
    left: 0;
    background-color: #ffb74d;
    transform-origin: bottom right;
    transition: transform 0.3s ease-out;
  }

  .developer-credit a:hover::after {
    transform: scaleX(1);
    transform-origin: bottom left;
  }

  .developer-credit .heart {
    color: #ff4d4d;
    display: inline-block;
    animation: heartbeat 1.5s infinite;
    margin: 0 2px;
  }

  .dev-name {
    letter-spacing: 1px;
    text-transform: uppercase;
    font-size: 12px;
  }

  @keyframes heartbeat {
    0%, 100% { transform: scale(1); }
    15% { transform: scale(1.3); }
    30% { transform: scale(1); }
    45% { transform: scale(1.3); }
    60% { transform: scale(1); }
  }

  /* 🌟 Tablet view */
  @media (max-width: 900px) {
    padding: 40px 10px 15px;

    .footer-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      text-align: center;
    }

    .footer-section {
      max-width: 90%;
    }

    .footer-section h2,
    .footer-section h3 {
      font-size: 15px;
      margin-bottom: 8px;
    }

    .footer-section p,
    .footer-section a {
      font-size: 13px;
      line-height: 1.5;
    }

    .footer-logo {
      width: 100px;
      margin-bottom: 10px;
    }

    .about {
      text-align: center;
    }

    .nav {
      text-align: center;
    }

    .collections {
      text-align: center;
    }

    .contact {
      text-align: center;
    }

    .contact-item {
      justify-content: center;
      margin: 8px auto;
      font-size: 13px;
    }

    .social-icons {
      justify-content: center;
      margin-top: 15px;
      gap: 14px;
    }

    .social-icons img {
      width: 30px;
      height: 30px;
      padding: 5px;
    }

    /* ✅ Compact, centered Browse & Collections */
    .nav ul,
    .collections ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 15px 25px;
      padding: 0;
      margin: 8px 0 0 0;
    }

    .nav ul li,
    .collections ul li {
      margin: 0;
      font-size: 13px;
      line-height: 1.4;
    }

    .footer-bottom {
      font-size: 12px;
      padding-top: 15px;
      margin-top: 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 15px;
    }

    .developer-credit {
      padding: 10px 20px;
    }
  }

  /* 🌟 Mobile view */
  @media (max-width: 600px) {
    padding: 40px 10px 15px;

    .footer-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      text-align: center;
    }

    .footer-section {
      max-width: 90%;
    }

    .footer-section h2,
    .footer-section h3 {
      font-size: 15px;
      margin-bottom: 8px;
    }

    .footer-section p,
    .footer-section a {
      font-size: 13px;
      line-height: 1.5;
    }

    .contact-item {
      justify-content: center;
      margin: 8px auto;
      font-size: 13px;
    }

    .social-icons {
      justify-content: center;
      margin-top: 15px;
    }

    /* ✅ Compact, centered Browse & Collections */
    .nav,
    .collections {
      text-align: center;
    }

    .nav ul,
    .collections ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 15px 25px;
      padding: 0;
      margin: 8px 0 0 0;
    }

    .nav ul li,
    .collections ul li {
      margin: 0;
      font-size: 13px;
      line-height: 1.4;
    }

    .footer-bottom {
      font-size: 12px;
      margin-top: 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 15px;
    }

    .developer-credit {
      padding: 10px 15px;
      width: 95%;
    }

    .developer-credit p {
      font-size: 12px;
    }
  }
`;

export default Wrapper;
